export const SToolbarWrapper = {
  pl: { sm: 2 },
  pr: { xs: 1, sm: 1 }
};

export const STypography = {
  flex: '1 1 100%'
};
